// (function ($) {
//   /**
//    * initMap
//    *
//    * Renders a Google Map onto the selected jQuery element
//    *
//    * @date    22/10/19
//    * @since   5.8.6
//    *
//    * @param   jQuery $el The jQuery element.
//    * @return  object The map instance.
//    */
//   function initMap($el) {
//     var $markers = $el.find('.marker');
//     var mapArgs = {
//       zoom: $el.data('zoom') || 16,
//       mapTypeId: google.maps.MapTypeId.ROADMAP,
//     };
//     var map = new google.maps.Map($el[0], mapArgs);
//     map.markers = [];
//     $markers.each(function () {
//       initMarker($(this), map);
//     });
//     centerMap(map);
//     return map;
//   }
//   /**
//    * initMarker
//    *
//    * Creates a marker for the given jQuery element and map.
//    *
//    * @date    22/10/19
//    * @since   5.8.6
//    *
//    * @param   jQuery $el The jQuery element.
//    * @param   object The map instance.
//    * @return  object The marker instance.
//    */
//   function initMarker($marker, map) {
//     var lat = $marker.data('lat');
//     var lng = $marker.data('lng');
//     var latLng = {
//       lat: parseFloat(lat),
//       lng: parseFloat(lng),
//     };
//     var marker = new google.maps.Marker({
//       position: latLng,
//       map: map,
//     });
//     map.markers.push(marker);
//     if ($marker.html()) {
//       var infowindow = new google.maps.InfoWindow({
//         content: $marker.html(),
//       });
//       google.maps.event.addListener(marker, 'click', function () {
//         infowindow.open(map, marker);
//       });
//     }
//   }
//   /**
//    * centerMap
//    *
//    * Centers the map showing all markers in view.
//    *
//    * @date    22/10/19
//    * @since   5.8.6
//    *
//    * @param   object The map instance.
//    * @return  void
//    */
//   function centerMap(map) {
//     var bounds = new google.maps.LatLngBounds();
//     map.markers.forEach(function (marker) {
//       bounds.extend({
//         lat: marker.position.lat(),
//         lng: marker.position.lng(),
//       });
//     });
//     if (map.markers.length == 1) {
//       map.setCenter(bounds.getCenter());
//     } else {
//       map.fitBounds(bounds);
//     }
//   }
//   $(document).ready(function () {
//     $('.acf-map').each(function () {
//       let map = initMap($(this));
//       // initMap($(this));
//     });
//   });
// })(jQuery);
